export default {
  tip: ' have access to the checkout page or not？',
  label: {
    amount: 'amount',
    code: 'channel code',
    merchantNo: 'merchant account',
    notifyUrl: 'callback address',
    outTradeNo: 'trading code',
    sign: 'signature',
    timestamp: 'choose time',
    type: 'Payment type',
    getmerchantNo: 'Get order transaction',
    payLine: 'Payment line',
    checkout: 'checkout'
  },
  rules: {
    amount: {
      required: 'the amount cannot be left blank',
      type: 'the amount must be in numeric format'
    },
    code: {
      required: 'the channel code cannot be left blank'
    },
    merchantNo: {
      required: 'Merchant accounts cannot be left blank'
    },
    notifyUrl: {
      required: 'The callback address cannot be left blank',
      format: 'The required callback address is http'
    },
    outTradeNo: {
      required: 'transaction code cannot be left blank'
    },
    selfMerchantNo: {
      required: 'Merchant order transaction must be obtained'
    },
    sign: {
      required: 'the signature cannot be left blank'
    },
    timestamp: {
      required: 'choose time'
    },
    type: {
      required: 'Required payment type select'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/channelTest.js